import { action_types } from "./actions";

import AuthService from "../services/AuthService";

export function getReducer(
  initialAuthenticationToken,
  initialUser,
  logoutService
) {
  const initialState = {
    // Authentication and user related state

    token: initialAuthenticationToken,
    isAuthenticated: !!initialAuthenticationToken,
    user: initialUser || {},
    title: AuthService.get_title(),
    page_filter: AuthService.get_page_filter(),
    help_text: AuthService.get_help_text(),
  };

  return function reducer(state = initialState, action) {
    let keepLoggedStorage = localStorage.getItem("user_logged_storage");
    if (
      (!keepLoggedStorage || keepLoggedStorage === "false") &&
      action.type !== "SET_AUTHENTICATION" &&
      window.location.pathname === "/"
    ) {
      action.type = "LOGOUT";
    }
    switch (action.type) {
      case action_types.SET_AUTHENTICATION:
        return {
          ...state,
          token: action.data.token,
          isAuthenticated: true,
          user: {
            nome: action.data.nome,
            email: action.data.email || null,
          },
        };
      case action_types.LOGOUT:
        // logoutService();
        return {
          ...state,
          token: null,
          isAuthenticated: false,
          user: null,
        };
      case action_types.ADD_NEW_TITLE:
        AuthService.save_title(action.title);
        return {
          ...state,
          title: action.title,
        };
      case action_types.ADD_NEW_PAGE_FILTER:
        AuthService.save_page_filter(action.page_filter);
        return {
          ...state,
          page_filter: action.page_filter,
        };
      case action_types.ADD_NEW_HELP_TEXT:
        AuthService.save_help_text(action.help_text);
        return {
          ...state,
          help_text: action.help_text,
        };
      default:
        return state;
    }
  };
}
